export default {
  schema: {
    type: 'object',
    properties: {
      sample: {
        title: 'Sample Question',
        type: 'string'
      }
    }
  },
  uiSchema: {
    'ui:title': {
      text: '<b>Screen Name</b>',
      escape: false
    },
    sample: {
      'ui:widget': 'text'
    },
    'dm:layout': [{
      type: 'field',
      id: 'sample'
    }]
  },
  formData: {}
};